// 27KH #109219 add
import { call, put, all, takeLeading } from 'redux-saga/effects'
import { openSnackbar, openModal } from 'reducers/messageReducer'
import { finishLoading, getloginPermissionIpAddressDetail, setIpAddressCreate, setloginPermissionIpAddressDetail, startLoading } from 'reducers/loginPermitIpAddressReducer'
import { loginPermissionIpAddressCreate, loginPermissionIpAddressDetailRequest } from 'apis/MCBMS010Api'
import { routeList } from 'routes/routes'
import history from 'utils/history'

function* setIpAddressCreateSaga(action: ReturnType<typeof setIpAddressCreate>) {
  try {
    const message = yield call(loginPermissionIpAddressCreate, action.payload);
    history.push(routeList.commonSettingsMenu);
      yield put(openSnackbar(message));
  } catch (error) {
    yield put(openModal(error.message));
  }
}

function* getloginPermissionIpAddressDetailSaga(action: ReturnType<typeof getloginPermissionIpAddressDetail>) {
  try {
    // 27KH #11020 Start
    yield put(startLoading()); 
    // 27KH #11020 End
    const data = yield call(loginPermissionIpAddressDetailRequest);
    yield put(setloginPermissionIpAddressDetail(data));
  } catch (error) {
    yield put(openModal(error.message));
  // 27KH #11020 Start
  } finally {
    yield put(finishLoading()); 
  }
  // 27KH #11020 End
}


export default function* loginPermitIpAddressSaga() {
  yield all([
    takeLeading(setIpAddressCreate, setIpAddressCreateSaga),
    takeLeading(getloginPermissionIpAddressDetail, getloginPermissionIpAddressDetailSaga),
  ])
}
